module.exports = __webpack_public_path__ + "img/add.841d3ab9.svg";